import styled from 'styled-components';
import { media, space, rems } from '../../ui/helpers';
import fonts from '../../ui/fonts';
import { MAIN_MENU_HEIGHT } from '../../ui/settings';
import { colors } from '../../ui/design-tokens';

const Module = styled.div<{ centered?: boolean; forceCenter?: boolean }>`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.text};
  padding: ${space(4)} ${space(3)} ${space(6)};
  background-color: ${colors.neutral[1000]};
  align-items: ${({ centered, forceCenter }) => forceCenter || centered ? 'center' : 'flex-start'};
  text-align: ${({ centered, forceCenter }) => forceCenter || centered ? 'center' : 'left'};

  .description {
    margin: ${space(4)} 0;
    padding: 0;
    ${fonts.highlightsMD} !important;
    text-align: ${({ centered, forceCenter }) => forceCenter || centered ? 'center' : 'left'};
  }

  .ctaContainer {
    margin-top: ${space(4)};
    margin-bottom: ${space(8)};
    text-align: ${({ centered, forceCenter }) => forceCenter || centered ? 'center' : 'left'};

    a:hover {
      background: ${colors.neutral[100]};
      color: ${colors.neutral[800]};
    }
  }

  .video-container {
    width: 100%;
    max-width: 1000px; /* ancho máximo ampliado */
    margin: ${space(4)} auto;
    background-color: ${colors.neutral[1000]};

    &.youtube-container {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 aspect ratio */
      height: 0;
      overflow: hidden;
      min-height: 280px; /* asegura altura mínima en móvil */

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
    }
  }

  ${media.min('medium')`
    flex-direction: row;
    align-items: stretch;
    min-height: ${rems(70)};
    padding: 50px 60px;
    align-items: ${({ forceCenter }) => (forceCenter ? 'center' : 'stretch')};
    text-align: ${({ forceCenter }) => (forceCenter ? 'center' : 'left')};

    .description, .ctaContainer {
      text-align: ${({ forceCenter }) => (forceCenter ? 'center' : 'left')};
    }

    .video-container {
      margin: ${space(4)} 0;

      &.youtube-container {
        min-height: 460px;
      }
    }
  `}
`;

const Top = styled.div<{ centered?: boolean; forceCenter?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ centered, forceCenter }) => forceCenter || centered ? 'center' : 'flex-start'};
  text-align: ${({ centered, forceCenter }) => forceCenter || centered ? 'center' : 'left'};

  &:first-child {
    margin-top: 0;
  }

  .title {
    font-weight: 200 !important;
  }

  ${media.min('medium')`
    align-items: ${({ forceCenter }) => (forceCenter ? 'center' : 'flex-start')};
    text-align: ${({ forceCenter }) => (forceCenter ? 'center' : 'left')};
    justify-content: center;
    padding-top: ${rems(60)};
  `}
`;

const Img = styled.div`
  width: 100%;
  max-width: ${rems(400)};
  margin: 0 auto ${rems(20)};

  ${media.min('medium')`
    width: 50%;
    height: auto;
    max-width: none;
    margin: 0;
    order: 2;

    .image {
      object-fit: cover;
      width: 100%;
      height: auto;
    }
  `}

  .image {
    width: 100%;
    height: auto;
    display: block;
  }

  .icon {
    background: ${colors.neutral[100]};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${rems(40)};
    width: ${rems(40)};
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -10%);

    ${media.min('medium')`
      height: ${rems(80)};
      width: ${rems(80)};
    `}

    .svg {
      path {
        fill: ${colors.neutral[800]};
      }
    }
  }

  &.showVideo {
    display: none;
  }

  &:hover {
    cursor: pointer;
  }
`;

const Bottom = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: center;

  &.hideVideo {
    display: none;
  }

  &.showVideo {
    display: flex;
    max-width: 800px;
  }

  ${media.min('medium')`
    .ctaContainer {
      margin-top: ${space(6)};
    }
  `}
`;

export const ResponsiveVideo = styled.video`
  max-width: 100%;
  height: 160px;

  ${media.min('medium')`
    height: 460px;
  `}
`;

export { Module, Top, Bottom, Img };
